import React from 'react';
import classnames from 'classnames/bind';
import styles from './ProfileSlideV4.css';

const cx = classnames.bind(styles);

const STAGES = [
    { period: 'Today', title: 'Where you grew up', hint: 'you don’t need writing skills' },
    { period: 'Weeks 2–4', title: 'The people you grew up with' },
    { period: 'Weeks 5–8', title: 'Moments you never want to forget' },
    { period: 'Week 12 and on', title: 'Your digital book keeps growing' }
];

function ProfileSlideV4() {
    return (
        <section className={styles.form}>
            <h2 className={styles.heading}>Your book starts with one easy question</h2>
            <p className={styles.description}>Built from your answers. Moves at your pace.</p>
            <ol className={styles.timeline}>
                {STAGES.map((stage, index) => (
                    <li key={stage.title} className={cx('stage', { isCurrent: index === 0 })}>
                        <span className={styles.marker}>{index + 1}</span>
                        <div className={styles.copy}>
                            <p className={styles.period}>{stage.period}</p>
                            <p className={styles.title}>{stage.title}</p>
                            {Boolean(stage.hint) && <p className={styles.hint}>{stage.hint}</p>}
                        </div>
                    </li>
                ))}
            </ol>
        </section>
    );
}

export {
    ProfileSlideV4
};
